<template>
    <div v-show="isAddNewUserToLocationModalVisible">
        <transition v-if="is_first_screen_visible" name="slide">
            <div class="modal-mask">
                <div class="modal-dialog modal-dialog-slideout modal-lg">
                    <div class="modal-content p-2">
                        <div class="modal-header">
                          <div class="width-100">
                            <a href="javascript:void(0);" @click="hide" class="text-uppercase text-muted pt-1"><img class="back_icon mr-2" src="@/assets/manager/back_button_icon.png" />Back</a>
                            <button type="button" class="close float-right" @click="hide">
                              <span aria-hidden="true">&times;</span>
                            </button>
                            <div class="clearfix"></div>
                          </div>

                        </div>
                        <div class="modal-body">
                          <div class="row mb-4">
                            <div class="col-9 pl-3">
                              <div class="h5 d-inline mr-2 text-uppercase">{{ setPageTitle }}</div>
                              
                            </div>
                          </div>                            
                            <div class="row">
                                <div class="col-12">
                                    <label class="form-label">
                                        Select Location
                                        <span class="required">*</span>
                                    </label>

                                    <select 
                                        name="account_name"
                                        id="account_name"
                                        v-model="selected_account_id"
                                        class="col-12 col-sm-12 input-height-35 form-control"
                                        @change="getLocationName($event)">
                                            <option value="">Select Location</option>
                                            <option 
                                                v-for="(type, index) in location_options" 
                                                :key="index" 
                                                :value="type.id"
                                            >
                                                {{ type.company_name }}
                                            </option>
                                    </select>
                                    <div v-if="!selected_account_id" :class="'margin-bottom-5 validate-warning-msg ' + vmessage">Location is required</div>
                                </div>
                            </div>
                            <div class="text-center end_btn">
                                <button type="button" :class="'btn btn-sm text-center ' + getBtnClass" @click="goToLastPage">{{ getBtnName }}</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </transition>
        <AddNewUser
            :isModalAddUserToLocationVisible="isModalAddUserToLocationVisible" 
            :accountId="selected_account_id"
            :accountName="selected_account_name"
            :userRoleType="user_role"
            :rolename="user_type"
            @close="closeNewUserSidebar"
            ref="add_new_user" 
        />
    </div>
</template>

<script>
import Vue from 'vue/dist/vue.esm';
import router from '../../router/index.js';
import axios from 'axios';
import AddNewUser from './add_new_user.vue';

export default {
    props: ['isAddNewUserToLocationModalVisible', 'user_type', 'user_role'],
    data() {
        return {
            loading: false,
            isModalAddUserToLocationVisible: false,
            selected_account_id: '',
            selected_account_name: '',
            location_options: [],
            vmessage: 'hide_message',
            is_first_screen_visible: true,
            program: '',
        }
    },
    components: {
        AddNewUser,
    },
    computed: {
        getBtnClass() {
            return (this.selected_account_id) ? 'ma-blue-btn' : 'greyBtn';
        },
        setPageTitle() {
            if (this.user_type) {
                return "Add New " + this.user_type;
            } else {
                return "Add New User";
            }
        },
        getBtnName() {
            if (this.user_type) {
                return "Add New " + this.user_type;
            } else {
                return "Add New User";
            }
        }
    },
    methods: {
        hide() {
            this.close();
        },
        close() {
            this.is_first_screen_visible = true;
            this.selected_account_id = '';
            this.location_options = [];
            this.vmessage = 'hide_vmessage';
            this.$emit('close');
        },
        closeNewUserSidebar() {
            this.selected_account_id = '';
            this.isModalAddUserToLocationVisible = false;
            this.is_first_screen_visible = true;
        },
        getLocations() {
            this.loading = true;
            this.location_options = [];
            this.vmessage = 'hide_vmessage';
            axios('/enterprise-admin/getAllLinkedLocations',
            {
                method: 'GET',
                params: {
                    "user_role": this.user_role,
                }
            })
            .then(response => {
                this.loading = false;
                this.location_options = response.data.locations;
            })
            .catch(() => {
            });
        },
        getLocationName(e) {
            axios('/enterprise-admin/location-overview',
                {
                    method: 'GET',
                    params: {
                        account_id: e.target.value,
                    }
                })
                .then(resp => {
                    this.program = resp.data.program;
                    this.selected_account_id = e.target.value;
                    this.selected_account_name = e.target.options[e.target.options.selectedIndex].text;
                })
                .catch(() => {
                });
        },
        goToLastPage() {
            if (this.selected_account_id) {
                this.is_first_screen_visible = false;
                this.isModalAddUserToLocationVisible = true;
                this.$refs.add_new_user.loadInitialData();
                this.vmessage = 'hide_vmessage';
            } else {
                this.vmessage = 'show_vmessage';
            }
        },
    }
}
</script>
<style scoped>
::-webkit-scrollbar {
    width: 0;  /* Remove scrollbar space */
    background: transparent;  /* Optional: just make scrollbar invisible */
}
.modal-mask {
    position: fixed;
    z-index: 1001;
    top: 59px;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .2);
    transition: opacity .3s ease;
    overflow-y: scroll;
}
.modal-dialog {
  animation: slide-in 1s forwards;
  -webkit-animation: slide-in 1s forwards;
}
@keyframes slide-in {
  0% {
    -webkit-transform: translateX(100%);
  }
  100% {
    -webkit-transform: translateX(0%);
  }
}

@-webkit-keyframes slide-in {
  0% {
    transform: translateX(100%);
  }
  100% {
    transform: translateX(0%);
  }
}
.modal-dialog {
  max-width: 90%;
}
@media (min-width: 992px) {
    .modal-lg, .modal-xl { width: 700px; }
}
@media (max-width: 576px){ 
    .modal-dialog.modal-dialog-slideout { width: 80% }
}
.modal-dialog-slideout {
    min-height: 100%; margin: 0 0 0 auto; background: #fff; 
}
.modal-dialog-slideout .modal-content{ border: 0; }
.modal-header { border-bottom: none; }
.modal-footer { border-top: none; }
.modal-goback { font-size: 24px; margin: 5px 10px 0 0; cursor: pointer; }
.modal-title { font-weight: 900; }
.maheading_1 { width: 5%; }
.maheading_2 { width: 75%; }
.maheading_3 { width: 20%; }
.ma-blue-btn, .ma-blue-btn:hover, .ma-blue-btn:active, .ma-blue-btn:focus {
  color: #FFF; 
  border-radius: 10px;
  width: 100%;
}
.greyBtn, .greyBtn:focus, .greyBtn:active{
    color: #FFF; 
    background-color: #c3c3c3 !important;
    border: 1px solid #c3c3c3 !important;
    border-radius: 10px;
    width: 100%;
}
.greyBtn:focus {
    box-shadow: none;
}
.hide_vmessage {
  display: none !important;
}
.show_vmessage {
  display: block !important;
}
.ma-input-field {
  line-height: 30px;
  margin-bottom: 5px;
  padding: 0 5px;
  border: 0 none;
  background-color: #efefef;
  min-height: 38px;
}
.ma-input-field:focus-visible {
  outline: none;
}
.form-label { font-size: 13px; font-weight: 900; } 
.end_btn { width: 50%; margin: 10rem auto auto auto; }
.back_icon { width: 14px; }
a, a:hover {
    text-decoration: none;
}
input, select {
    line-height: 17px;
    border-radius: 10px;
    padding-left: 5px !important;
    border: 1px solid #707070;
}

</style>


// WEBPACK FOOTER //
// src/components/enterpriseadmin/add_new_user_to_location.vue